import { render, staticRenderFns } from "./ProfessionaAvailability.vue?vue&type=template&id=5647326c"
import script from "./ProfessionaAvailability.vue?vue&type=script&lang=js"
export * from "./ProfessionaAvailability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports